import { apiRequest } from '../api/client';

/** Matches `apps/api` `StoredPaymentMethodWithUsage` (`payment-method.repository.ts`). */
export interface PaymentMethod {
  id: string;
  name: string;
  isActive: boolean;
  paymentUsageCount: number;
  createdAt: string;
  updatedAt: string;
}

/** Matches `apps/api` `GET /payment-methods` (`settings.manage`). */
export function listPaymentMethods(): Promise<PaymentMethod[]> {
  return apiRequest<PaymentMethod[]>('/payment-methods');
}

/** Matches `apps/api` `PaymentMethodOption` (`list-payment-methods.use-case.ts`). */
export interface PaymentMethodOption {
  id: string;
  name: string;
}

/** Matches `apps/api` `GET /payment-methods/options` (`payment.register`; active methods only). */
export function listPaymentMethodOptions(): Promise<PaymentMethodOption[]> {
  return apiRequest<PaymentMethodOption[]>('/payment-methods/options');
}

export interface CreatePaymentMethodInput {
  name: string;
  isActive?: boolean;
}

/** Matches `apps/api` `POST /payment-methods`. */
export function createPaymentMethod(input: CreatePaymentMethodInput): Promise<PaymentMethod> {
  return apiRequest<PaymentMethod>('/payment-methods', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export type UpdatePaymentMethodInput = Partial<CreatePaymentMethodInput>;

/** Matches `apps/api` `PATCH /payment-methods/:id`. */
export function updatePaymentMethod(
  id: string,
  input: UpdatePaymentMethodInput,
): Promise<PaymentMethod> {
  return apiRequest<PaymentMethod>(`/payment-methods/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
